import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.4/js/sparta-store-utility";
const ps = new WeakMap();

const TRAILING_QUESTION_AMPERSAND_REGEX = /[?&]$/;






export default class Transport {


















  constructor(opts, globalConfig) {
    const defaults = {
      cache: true,
      data: null,
      headers: {}, 
      method: 'GET',
      timeout: 0,
      xhrFields: {
        widthCredentials: false,
      },
    };

    const options = { ...defaults, ...opts };
    const { beforeSend, cache, complete, data, error, method, success, timeout, xhrFields } = options; 


    let { crossDomain, contentType } = options;
    if (typeof contentType === 'undefined' && ['GET', 'HEAD'].indexOf(method) === -1) contentType = 'application/x-www-form-urlencoded; charset=UTF-8';

    const {
      globalError,
      globalComplete,
      globalSuccess,
    } = globalConfig;


    const xhr = new XMLHttpRequest();


    const nativeGetResponseHeader = xhr.getResponseHeader.bind(xhr);
    const nativeSetRequestHeader = xhr.setRequestHeader.bind(xhr);
    const nativeXHRAbort = xhr.abort.bind(xhr);

    xhr.abort = () => { this.options.shouldAbort = true; };


    ps.set(this, {
      xhr,
      status,
      ...options,
      globalConfig,
      nativeGetResponseHeader,
      nativeSetRequestHeader,
      nativeXHRAbort,
      completed: false,
      called: {},
    });

    const urlObj = Transport.getUrlInfo(this.options.url);
    const reqData = { ...this.options.data };


    if (typeof crossDomain === 'undefined') crossDomain = window.location.origin !== urlObj.origin;


    let urlRequestString = `${this.options.url}${urlObj.search ? '&' : '?'}`;


    let payload = contentType && contentType.indexOf('application/json') !== -1 && typeof data === 'string' ? data : this.buildUrlQueryString(data);
    payload = payload === '' ? null : payload;


    if (['GET', 'HEAD'].indexOf(method) > -1 && (cache === false || this.dataType === 'script')) {
      reqData._ = (new Date()).getTime();
    }


    if (['GET', 'HEAD'].indexOf(method) > -1 && urlRequestString.length) {
      urlRequestString = `${urlRequestString}${urlRequestString.match(/\?$/) || urlObj.search ? '' : '?'}${this.buildUrlQueryString(reqData)}`;
    }


    urlRequestString = urlRequestString
    .replace(TRAILING_QUESTION_AMPERSAND_REGEX, '')
    .replace(TRAILING_QUESTION_AMPERSAND_REGEX, '');


    this.xhr.setRequestHeader = this.setRequestHeader.bind(this);


    if (beforeSend && typeof beforeSend === 'function') {
      const beforeSendResult = beforeSend.call(this.options, this.xhr, this.options);
      if (beforeSendResult === false) return;

      this.xhr.abort = nativeXHRAbort;

      ps.set(this, {
        ...options,
        ...ps.get(this),
        ...this.options,
      });

      if (this.options.url !== options.url) urlRequestString = this.options.url;
    }

    const reqHeaders = { ...this.options.headers };


    if (!crossDomain && !reqHeaders['X-Requested-With']) {
      reqHeaders['X-Requested-With'] = 'XMLHttpRequest';
    }



    if (!reqHeaders['Content-Type'] && contentType && contentType !== false) {
      reqHeaders['Content-Type'] = contentType;
    }


    this.xhr.open(method, urlRequestString, true);


    for (const i in reqHeaders) { 
      nativeSetRequestHeader(i, reqHeaders[i]);
    }


    this.xhr.withCredentials = xhrFields.withCredentials;


    this.xhr.getResponseHeader = this.getResponseHeader.bind(this);


    this.xhr.onreadystatechange = () => {

      if (
        (xhr.readyState === XMLHttpRequest.DONE && xhr.status >= 200 && xhr.status < 300)
        || xhr.status === 304
      ) {
        this.onSuccess(success);

        if (globalSuccess && globalSuccess.doc && globalSuccess.cb) {
          this.onGlobalSuccess(globalSuccess.doc, globalSuccess.cb);
        }

        ps.get(this).completed = true;
      }


      if (
        (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 0)
        || (xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && xhr.status >= 400)
      ) {

        if (!this.options.called.error) this.onError(error);

        if (!this.options.called.globalError && globalError && globalError.doc && globalError.cb) {
          this.onGlobalError(
            globalError.doc,
            globalError.cb,
          );
        }
      }


      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (!this.options.called.complete) this.onComplete(complete);

        if (
          !this.options.called.globalComplete
          && globalComplete
          && globalComplete.doc
          && globalComplete.cb
        ) {
          this.onGlobalComplete(globalComplete.doc, globalComplete.cb);
        }
      }
    };

    this.xhr.ontimeout = () => {
      this.onError(error, 'timeout');

      if (globalError && globalError.doc && globalError.cb) {
        this.onGlobalError(globalError.doc, globalError.cb, 'timeout');
      }
    };


    this.xhr.timeout = timeout;


    if (!this.options.shouldAbort) this.xhr.send(payload);
  }





  fakeAbort() {
    this.options.shouldAbort = true;
  }




  abort() {
    this.options.called.error = true;
    this.options.called.complete = true;

    this.xhr.abort();
    this.onError(this.options.error, 'abort');
    this.onComplete(this.options.complete);

    if (
      !this.options.called.globalComplete
      && this.options.globalConfig.globalComplete
      && this.options.globalConfig.globalComplete.doc
      && this.options.globalConfig.globalComplete.cb
    ) {
      this.onGlobalComplete(
        this.options.globalConfig.globalComplete.doc,
        this.options.globalConfig.globalComplete.cb,
      );
    }
  }






  buildUrlQueryString(obj, prefix) {
    const str = [];

    for (const p in obj) { 
      if (Object.prototype.hasOwnProperty.call(obj, p)) {
        const k = prefix ? `${prefix}[${p}]` : p;
        const v = obj[p];
        const qStr = (v !== null && typeof v === 'object')
        ? this.buildUrlQueryString(v, k)
        : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;

        str.push(qStr);
      }
    }

    return str.join('&');
  }





  static getUrlInfo(url) { 
    let a;
    if (!a) a = document.createElement('a');
    a.href = url;
    return a;
  }







  onGlobalSuccess(doc, onGlobalSuccessCB) {
    if (doc === document && typeof onGlobalSuccessCB === 'function') {
      onGlobalSuccessCB.call(doc, {
        currentTarget: doc,
        target: doc,
      }, this.xhr, this.options, this.getXHRData());
    }
  }







  onGlobalError(doc, onGlobalErrorCB, status = 'error') {
    this.options.called.globalError = true;

    if (doc === document && typeof onGlobalErrorCB === 'function') {
      onGlobalErrorCB.call(doc, {
        currentTarget: doc,
        target: doc,
      }, this.xhr, this.options, status);
    }
  }







  onGlobalComplete(doc, onGlobalCompleteCB) {
    this.options.called.globalComplete = true;

    if (doc === document && typeof onGlobalCompleteCB === 'function') {
      onGlobalCompleteCB.call(doc, {
        currentTarget: doc,
        target: doc,
      }, this.xhr, this.options);
    }
  }





  onError(onErrorCB, status = 'error') {
    this.options.called.error = true;

    if (typeof onErrorCB === 'function') {
      this.status = status;
      const statusText = this.xhr.statusText === '' ? status : this.xhr.statusText;
      onErrorCB(this.xhr, this.status, statusText);
    }

    return null;
  }






  onComplete(onCompleteCB) {
    this.options.called.complete = true;

    if (onCompleteCB && typeof onCompleteCB === 'function') {
      onCompleteCB.call(this.options, this.xhr, this.status);
    }

    return null;
  }





  onSuccess(onSuccessCB) {
    this.options.called.success = true;

    const data = this.getXHRData();


    if (onSuccessCB && typeof onSuccessCB === 'function') {
      this.status = 'success';
      return onSuccessCB.call(this.options, data, this.status, this.xhr);
    }

    return null;
  }




  getXHRData() {
    const contentTypes = {
      json: 'application/json',
      xml: 'application/xml',
      html: 'text/html',
      script: 'application/javascript',
    };

    if (!this.dataType) {
      for (const type in contentTypes) { 
        if (this.xhr.getResponseHeader('Content-Type').indexOf(type) !== -1) this.dataType = type;
      }
    }

    if (this.xhr.responseText === '') return undefined;


    switch (this.dataType) {
      case 'json':
        try {
          return JSON.parse(this.xhr.responseText);
        } catch(e) {
          return undefined;
        }
      case 'xml':
        return this.xhr.responseXML;
      case 'script':
      case 'html':
      default:
        return this.xhr.responseText;
    }
  }





  parseXML(xmlData) { 
    let xml;

    if (!xmlData || typeof xmlData !== 'string') return null;



    try {
      xml = (new window.DOMParser()).parseFromString(xmlData, 'text/xml');
    } catch (e) {            }

    if (!xml || xml.getElementsByTagName('parsererror').length) {
      throw new Error(`Invalid XML: ${xmlData}`);
    }

    return xml;
  }







  setRequestHeader(key, val) {
    this.options.headers[key] = val;
  }





  getResponseHeader(key) {
    const rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg;
    const responseHeaders = {};
    let match;

    while ((match = rheaders.exec(this.xhr.getAllResponseHeaders()))) { 
      responseHeaders[match[1].toLowerCase()] = match[2];
    }

    match = responseHeaders[key.toLowerCase()];
    return match;
  }




  get options() {
    return ps.get(this);
  }




  set status(status) {
    ps.get(this).status = status;
  }




  get status() {
    return ps.get(this).status;
  }




  set dataType(type) {
    this.options.dataType = type;
  }




  get dataType() {
    return this.options.dataType;
  }




  get xhr() {
    return ps.get(this).xhr;
  }
}
